import React, { useState } from 'react';
import { useMantineColorScheme } from '@mantine/core';
import Layout1 from '../../Layout/Layout1';
import TabBarV2 from '../../../components/TabBar/TabBarV2';
import styles from './DetailsPage.module.css';
import OverviewTab from './OverviewTab';
import PositionsTabV2 from '../../DetailPages/CommonDetailsComponent/PositionsTabV2';
import ClosedPositionsTabV2 from '../../DetailPages/CommonDetailsComponent/ClosedPositionsTabV2';
import WalletTabV2 from '../../DetailPages/CommonDetailsComponent/WalletTabV2';
import OrdersTabV2 from '../../DetailPages/CommonDetailsComponent/OrdersTabV2';
import TransfersTabV2 from '../../DetailPages/CommonDetailsComponent/TransfersTabV2';

const DetailsPage = () => {
  const [tabName, changeTab] = useState('overview');

  const { colorScheme } = useMantineColorScheme();

  const tabBarOptions = [
    {
      label: 'Overview',
      value: 'overview',
    },
    {
      label: 'Positions',
      value: 'positions',
    },
    {
      label: 'Closed Positions',
      value: 'closedPositions',
    },
    {
      label: 'Wallet',
      value: 'wallet',
    },
    {
      label: 'Orders',
      value: 'orders',
    },
    {
      label: 'Transfers',
      value: 'transfers',
    },
  ];
  return (
    <div>
      <Layout1>
        <div className="flex flex-col h-full overflow-hidden">
          <div className={`${styles.mainContainerLayout} h-[60px] flex items-center border-b w-screen sticky top-0 z-10 ${colorScheme === 'dark' && 'border-neutral-500'}`}>
            <div className="flex flex-wrap" id={styles.tabsId}>
              <div className="w-full">
                <TabBarV2
                  options={tabBarOptions}
                  tabName={tabName}
                  handleChange={(e) => changeTab(e)}
                />
              </div>
            </div>
          </div>

          {/* <div className="px-0 relative w-full">
            <div
              className="absolute w-full h-full top-0 left-0"
            >
              {
                tabName === 'overview'
                && (
                  <OverviewTab pageName="CompanyData" />
                )
              }
            </div>
          </div> */}
          <div className="px-[79px] py-7 flex-1 overflow-y-auto">
            {tabName === 'overview' && (
              <OverviewTab pageName="CompanyData" />
            )}
            {tabName === 'positions' && (
              <PositionsTabV2 pageName="CompanyData" />
            )}
            {tabName === 'closedPositions' && (
              <ClosedPositionsTabV2 pageName="CompanyData" />
            )}
            {tabName === 'wallet' && (
              <WalletTabV2 pageName="CompanyData" />
            )}
            {tabName === 'orders' && (
              <OrdersTabV2 pageName="CompanyData" />
            )}
            {tabName === 'transfers' && (
              <TransfersTabV2 pageName="CompanyData" />
            )}
          </div>
        </div>
      </Layout1>
    </div>
  );
};

export default DetailsPage;
